import { render, staticRenderFns } from "./AnaliseDocumentacaoDocumentoCredenciamento.vue?vue&type=template&id=c70fd95a"
import script from "./AnaliseDocumentacaoDocumentoCredenciamento.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacaoDocumentoCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacaoDocumentoCredenciamento.vue?vue&type=style&index=0&id=c70fd95a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports